module.exports = { "default": require("core-js/library/fn/is-iterable"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /app/~/babel-runtime/core-js/is-iterable.js
// module id = ../../../../babel-runtime/core-js/is-iterable.js
// module chunks = 7